import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-brand-gold bg-brand-mint" data-id="element-103" data-mp="8n57vub2jyg6">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-104" data-mp="dg87aj2j224a">
        <p className="inline-block rounded-md bg-brand-petrol px-2 py-0.5 font-sub text-xs font-semibold uppercase tracking-widest text-brand-gold" data-id="element-105" data-mp="icgixmhind6p">
          Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-display text-[2rem] leading-none text-brand-petrol sm:text-5xl" data-id="element-106" data-mp="rf7t7iyno2wr">
          Comenzá desde los fundamentos y avanzá a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-2xl border-4 border-dashed border-brand-petrol bg-white text-brand-petrol" data-id="element-107" data-mp="2t743yqd018qh">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block" data-id="element-108" data-mp="12n8k3ov69ojk">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-109" data-mp="xv8ryilcfzxj" />
          </a>
          <div className="p-3" data-id="element-110" data-mp="oxeswzw72s6o">
            <p className="font-sub text-sm font-bold uppercase leading-tight text-brand-emerald" data-id="element-111" data-mp="ouaj9mzyn48m">
              {PRODUCT_NAME}
            </p>
            <p className="mt-0.5 font-display text-3xl leading-none" data-id="element-112" data-mp="1gn1kkbwi3j4q">
              6 Tomos + 5 Bonos
            </p>
            <p className="mt-0.5 text-xs text-brand-muted sm:text-sm" data-id="element-113" data-mp="1ckd7fs0r7q1y">
              🎁 Cinco recursos de estudio incluidos.
            </p>

            <p className="mt-2 font-display text-6xl leading-none text-brand-emerald sm:text-7xl" data-id="element-114" data-mp="17oxur3ehg074">
              <span className="text-3xl text-brand-petrol sm:text-4xl" data-id="element-115" data-mp="146jjqpw7omw">Precio:</span>{' '}
              {PRICE}{' '}
              <span className="text-3xl text-brand-petrol sm:text-4xl" data-id="element-116" data-mp="3tu99x98xnfit">ARS</span>
            </p>
            <p className="mt-1 text-xs font-semibold text-brand-muted" data-id="element-117" data-mp="2ng946i1xiet">
              Pago único • Sin mensualidades • Material digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-118" data-mp="3ksrsnnjsh7sj">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>
          </div>
        </Reveal>
      </div>
    </section>;
}